type CloseIconProps = {
  style?: React.CSSProperties
  className?: string
}

export const CloseIcon: React.FC<CloseIconProps> = ({ style, className }) => (
  <svg
    style={style}
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 2.575L17.425 1L10 8.425L2.575 1L1 2.575L8.425 10L1 17.425L2.575 19L10 11.575L17.425 19L19 17.425L11.575 10L19 2.575Z"
      fill="currentColor"
    />
  </svg>
)
